// Helper functions for Fill in the Blank component

export const getAvailableOptions = (blanks, userAnswers, textToIdxMap = {}) => {
  if (!blanks || blanks.length === 0) return [];
  
  const allOptions = [];
  blanks.forEach((blank) => {
    blank.options.forEach((option) => {
      if (!allOptions.includes(option)) {
        allOptions.push(option);
      }
    });
  });
  
  // userAnswers contains idx, convert to text for comparison
  const usedOptions = Object.values(userAnswers)
    .filter(idx => idx !== undefined && idx !== null)
    .map(idx => {
      // Find text from idx (reverse lookup)
      for (const [text, textIdx] of Object.entries(textToIdxMap)) {
        if (textIdx === idx) return text;
      }
      return null;
    })
    .filter(Boolean);
  
  return allOptions.filter(option => !usedOptions.includes(option));
};

export const parseSentenceWithBlanks = (text, blanks) => {
  if (!blanks || blanks.length === 0) return null;
  
  const parts = [];
  let currentText = text;

  blanks.forEach((blank, index) => {
    const blankId = blank.id || (index + 1);
    
    // Try [blank-X] format first (new format)
    let placeholder = `[blank-${blankId}]`;
    let placeholderIndex = currentText.indexOf(placeholder);
    
    // Fallback to {blankX} format (old format)
    if (placeholderIndex === -1) {
      placeholder = `{blank${blankId}}`;
      placeholderIndex = currentText.indexOf(placeholder);
    }
    
    // Fallback to {blankX} format with index
    if (placeholderIndex === -1) {
      placeholder = `{blank${index + 1}}`;
      placeholderIndex = currentText.indexOf(placeholder);
    }
    
    if (placeholderIndex !== -1) {
      if (placeholderIndex > 0) {
        parts.push({ type: 'text', content: currentText.substring(0, placeholderIndex) });
      }
      parts.push({ type: 'blank', blank, blankIndex: index });
      currentText = currentText.substring(placeholderIndex + placeholder.length);
    }
  });

  if (currentText.length > 0) {
    parts.push({ type: 'text', content: currentText });
  }

  return parts;
};

export const findFirstEmptyBlank = (blanks, userAnswers) => {
  const blanksWithStatus = blanks.map((blank, index) => ({
    blank,
    blankId: blank.id || index,
    isEmpty: userAnswers[blank.id || index] === undefined || userAnswers[blank.id || index] === null
  }));
  
  return blanksWithStatus.find(b => b.isEmpty);
};

export const checkAllBlanksFilled = (blanks, userAnswers) => {
  if (!blanks) return false;
  return blanks.every(blank => {
    const blankId = blank.id || blanks.indexOf(blank);
    // userAnswers contains idx (number), not text
    return userAnswers[blankId] !== undefined && userAnswers[blankId] !== null;
  });
};

export const validateAnswers = (blanks, userAnswers) => {
  let allCorrect = true;
  blanks.forEach((blank) => {
    const blankId = blank.id || blanks.indexOf(blank);
    const userAnswer = userAnswers[blankId]?.trim().toLowerCase();
    const correctAnswer = blank.correctAnswer?.trim().toLowerCase();
    if (userAnswer !== correctAnswer) allCorrect = false;
  });
  return allCorrect;
};

